import React, { useRef, useEffect } from "react";
import { Box, useTheme } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import { analyticsMenuOptions } from "../data/database";
import { customColour } from "../data/colour";

const SubMenu = ({ menuOptions, padding, fontSize }) => {
  const location = useLocation();
  // const { accentColour } = useColourMode();
  // const colourTheme = useTheme();

  const scrollRef = useRef(null);

  useEffect(() => {
    // Retrieve saved scroll position from session storage
    const savedScrollPosition = sessionStorage.getItem("scrollPosition");

    if (savedScrollPosition && scrollRef.current) {
      scrollRef.current.scrollLeft = parseInt(savedScrollPosition, 10);
    }

    // Save the current scroll position whenever it changes
    const handleScroll = () => {
      if (scrollRef.current) {
        sessionStorage.setItem("scrollPosition", scrollRef.current.scrollLeft);
      }
    };

    if (scrollRef.current) {
      scrollRef.current.addEventListener("scroll", handleScroll);
    }

    return () => {
      // Clean up scroll event listener
      if (scrollRef.current) {
        scrollRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, [location.pathname]); // Trigger whenever the route changes

  return (
    <Box
      ref={scrollRef}
      sx={{
        display: "flex",
        flexDirection: "row",
        overflowX: "auto", // Enable horizontal scrolling
        overflowY: "hidden", // Prevent vertical overflow
        WebkitOverflowScrolling: "touch", // Smooth scrolling on mobile devices
        "::-webkit-scrollbar": {
          display: "none", // Hide scrollbar for Webkit browsers
        },
        msOverflowStyle: "none", // Hide scrollbar for IE and Edge
        scrollbarWidth: "none", // Hide scrollbar for Firefox
      }}
    >
      {menuOptions.map((item, index) => {
        const isActive = location.pathname === item.path;

        return (
          <Box
            key={index}
            component={Link}
            to={item.path}
            sx={{
              color: isActive ? customColour.white : customColour.darkerBlue,
              backgroundColor: isActive
                ? customColour.darkerBlue
                : customColour.white,
              fontSize: fontSize,
              fontWeight: "200",
              borderRadius: "0.25rem",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "fit-content",
              padding: padding,
              textDecoration: "none",
              marginRight: "0.1rem",
              whiteSpace: "nowrap",
              "&:hover": {
                backgroundColor: customColour.darkBlue, // Hover background color
                color: customColour.white, // Optional: Change text color on hover
              },
            }}
          >
            {item.label}
          </Box>
        );
      })}
    </Box>
  );
};

export default SubMenu;
